import React from 'react'
import { AudioAnalyser } from '@bt-react/components/AudioSpectrum'
import DisabledIcon from '@bt-react/components/DisabledIcon'
import Icon, { IconType } from '@bt-react/components/Icon'
import style from './DialInSettingsStatus.module.scss'
import { DialInSettingsStatusProps, DialInSettingsStatusState } from './types'
import classnames from 'classnames'
import { debug } from '@bt-react/libs/Logger'

class DialInSettingsStatus extends React.Component<DialInSettingsStatusProps, DialInSettingsStatusState> {

  state = {
    hasStreamTrack: false,
    stream: typeof MediaStream !== 'undefined' ? new MediaStream() : undefined
  }

  componentDidMount () {

    if (this.props.remoteDialInAudioTrack) this.captureStream()

  }

  componentDidUpdate (prevProps) {

    if (!prevProps.remoteDialInAudioTrack && this.props.remoteDialInAudioTrack) this.captureStream()

  }

  componentWillUnmount () {

    if (this.state.stream) {

      try {

        for (const track of this.state.stream.getAudioTracks()) {

          this.state.stream.removeTrack(track)

        }

      }
      catch (e) {

        debug(e.message)

      }

    }

  }

  captureStream = (): void => {

    if (!this.props.remoteDialInAudioTrack || !this.state.stream) return

    this.state.stream.addTrack(this.props.remoteDialInAudioTrack.mediaStreamTrack)

    if (this.state.stream.getAudioTracks().length > 0) {

      this.setState({ hasStreamTrack: true })

    }

  }

  getConnectedPreviewContent = (): JSX.Element => {

    if (this.state.hasStreamTrack && this.state.stream) {

      return <AudioAnalyser
        audio={this.state.stream}
        spectrumProps = {{
          width: 60,
          height: 40,
          meterCount: 5,
          gap: 2,
          meterWidth: 10,
          meterColor: '#003CB2'
        }}

      />

    }

    return <div />

  }

  render () {

    const { isConnected = false } = this.props

    return <div className={style['dial-in-settings-status']} data-bdd='dial-in-settings'>
      <div className={style['dial-in-settings-icon']} data-bdd='dial-in-settings-status-content'>
        <Icon
          name={IconType.iconName.phone}
          className={style['dial-in-settings-phone-icon']}
        />
        <div className={classnames(
          style['dial-in-settings-disabled-icon'], {
            [style['dial-in-settings-disabled-icon--hidden']]: this.props.isConnected
          }
        )}>
          <DisabledIcon size='xs' />
        </div>
      </div>
      {
        isConnected && this.state.hasStreamTrack
          ? this.getConnectedPreviewContent()
          : <div className={style['dial-in-settings-text']} data-bdd='dial-in-settings-no-connection' >Phone not connected</div>
      }
    </div>

  }

}

export default DialInSettingsStatus
